<template>
  <div class="">
    <table class="table-common border-table">

      <!-- 会員ID -->
      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold">会員ID</div>
        </td>
        <td class="data">
          <span wovn-ignore>{{ info_person_form.memberId }}</span>
        </td>
      </tr>

      <!-- 申込者名 -->
      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold">申込者名</div>
        </td>
        <td class="data">
          <span class="mr-1" wovn-ignore>{{ info_person_form.familyName }}</span>
          <span wovn-ignore>{{ info_person_form.firstName }}</span>
          様
        </td>
      </tr>

      <!-- 申込者氏名（カナ） -->
      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold">申込者氏名（カナ）</div>
        </td>
        <td class="data">
          <span class="mr-1" wovn-ignore>{{ info_person_form.familyNameKana }}</span>
          <span wovn-ignore>{{ info_person_form.firstNameKana }}</span>
          様
        </td>
      </tr>

      <!-- 住所・郵便番号・都道府県・市区町村・番地・建物・号室（任意） -->
      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">ご住所</div>
          <div class="ml-4 category">必須</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data">郵便番号</div>
            <div class="content-data">
              <div class="flex mt-3 gap-2">
                <a-input
                  :maxLength="3"
                  placeholder=""
                  @input="validateZip1Number($event)"
                  v-model="zipCode1"
                  wovn-ignore
                />
                <span class="self-center">−</span>
                <a-input
                  :maxLength="4"
                  placeholder=""
                  @input="validateZip2Number($event)"
                  v-model="zipCode2"
                  wovn-ignore
                />
                <button @click="loadLocation()" class="c-btn-cm btn-white">
                  住所自動入力
                </button>
              </div>
              <div>※海外在住の方は「000-0000」とご入力ください。</div>
              <div class="text-primary font-bold">
                {{ error_message_zipcode }}
              </div>
            </div>
          </div>
          <div v-if="!isForeign">
            <div class="items-data">
              <div class="label-data">都道府県</div>
              <div class="content-data input-items">
                <div class="mt-3" wovn-ignore>
                  <a-select
                    class="select-items"
                    placeholder="選択してください "
                    v-model="prefectures"
                    wovn-ignore
                  >
                    <a-select-option v-for="(item, index) in getPrefecturesList" :key="index" :value="item.value" wovn-ignore>{{ item.label }}</a-select-option>
                  </a-select>
                </div>
                <div class="text-primary font-bold">
                  {{ error_message_prefectures }}
                </div>
              </div>
            </div>
            <div class="items-data">
              <div class="label-data">市区町村・番地</div>
              <div class="content-data input-items">
                <div class="mt-3">
                  <a-input
                    :maxLength="100"
                    placeholder=""
                    v-model.trim="cityAddress"
                    wovn-ignore
                  />
                </div>
                <div class="text-primary font-bold">
                  {{ error_message_cityAddress }}
                </div>
              </div>
            </div>
            <div class="items-data">
              <div class="label-data">建物・号室（任意）</div>
              <div class="content-data input-items">
                <div class="mt-3">
                  <a-input
                    placeholder=""
                    :maxLength="100"
                    v-model.trim="info_person_form.apartment_number"
                    wovn-ignore
                  />
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <!-- 連絡先メールアドレス -->
      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">ご連絡先<br />メールアドレス</div>
        </td>
        <td class="data">
          <div class="items-data" style="margin-top: 10px">
            <div class="content-data">
              <div class="flex gap-2 elements">
                <span wovn-ignore>{{ info_person_form.email }}</span>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <!-- 電話番号 -->
      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">ご連絡先<br />電話番号</div>
          <div class="ml-4 category">必須</div>
        </td>
        <td class="data">
          <div class="items-data">
              <div class="content-data w-full">
                <div class="mt-3 mb-2">
                  <a-input
                    placeholder="0312345678"
                    :maxLength="100"
                    v-model.trim="info_person_form.tel"
                    wovn-ignore
                  />
                </div>
                <p v-if="!error_message_tel" class="content__note--tel">
                  ※10桁以上、半角数字のみを入力してください。ハイフンの入力は不要です。
                </p>
                <div v-else class="text-primary font-bold">
                  {{ error_message_tel }}
                </div>
              </div>
            </div>
        </td>
      </tr>

      <tr class="label-inp"></tr>
    </table>
  </div>
</template>

<script>
import _ from 'lodash'
import { GET_LOCATE, UPDATE_INFO_DETAIL } from '@/store/modules/bs_app/actions'
import locateData from '@/jsons-data/locate.json'
import func_utils from '@/mixins/func_utils'
// import { Core as YubinBangoCore } from 'yubinbango-core2'
import { Core as YubinBangoCore } from '@/utils/yubinbango-core2/yubinbango-core'
import { codes } from '@/constants/prefectures'

export default {
  mixins: [func_utils],
  components: {},
  props: ['updateInfoComplete'],
  data() {
    return {
      customerPlan: null,
      email: 0,
      phone: 0,
      isEditEmail: false,
      isEditPhone: false,
      myEmail: '',
      myPhone: 0,
      firstEmail: '',
      secondEmail: '',
      firstTel: '',
      secondTel: '',
      zipCode1: '',
      zipCode2: '',
      prefectures: undefined,
      cityAddress: null,
      apartment_number: '',
      titleContent: ['お申し込み内容', '申込者情報'],
      error_message: 'メールアドレスを入力してください',
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申込確認.'
        },
        {
          id: 3,
          label: '申込完了'
        }
      ],
      error_message_email: null,
      error_message_phone: null,
      error_message_zipcode: null,
      error_message_prefectures: null,
      error_message_cityAddress: null,
      error_message_tel: null,
      hasError: false,
      info_person_form: {
        memberId: '',
        firstName: '',
        familyName: '',
        firstNameKana: '',
        familyNameKana: '',
        apartment_number: '',
        email: '',
        secondEmail: null,
        tel: '',
        secondTel: null
      },
      locate: locateData.locate,
      dataItemOrder: {},
      checkinTime: '',
      useCoupon: false,
      profileInfo: {},
      totalAdultPeople: 0,
      totalChildren: 0,
      textUnregister: '未登録',
      zipcodeError: false,
      isForeign: false,
      prefectureCode: 13
    }
  },
  mounted() {
    this.useCoupon = this.$store.getters.isUseCoupon
    this.useBenepoPoint = this.$store.getters.isUseBenepoPoint
    this.customerPlan = this.customerPlanState
    this.mountData()
    this.getProfileInfo()
  },
  computed: {
    profileMe() {
      return this.$store.getters['auth/get'].profileMe
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.getters, 'planDetail', null))
    },
    isRakutenPlan() {
      if (_.cloneDeep(_.get(this.$store.getters, 'planDetail.menuInformation.extSystemCd', null)) === 'RakutenT') return true
      return false
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.getters, 'customerPlan', null))
    },
    getInfoDetail() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.info_detail', null))
    },
    getDataBsApp02001() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.bs_app_02_001', null))
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    getPrefecturesList() {
      const list = []
      const prefecturesList = Object.entries(codes)
      prefecturesList.forEach((item) => {
        list.push({ label: item[1].name, value: item[1].name })
      })
      return list
    }
  },
  watch: {
    updateInfoComplete() {
      const errorInput = this.checkValidateInput()
      this.updateInfoDetail()
      if (!errorInput) {
        this.$emit('checkValidate', true)
      } else {
        this.$emit('checkValidate', false)
      }
    }
  },
  methods: {
    mountData() {
      const customerInfo = this.getInfoDetail ? this.getInfoDetail : null
      if (customerInfo) {
        this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
        this.info_person_form.firstName = customerInfo.firstName
        this.info_person_form.familyName = customerInfo.familyName
        this.info_person_form.firstNameKana = customerInfo.firstNameKana
        this.info_person_form.familyNameKana = customerInfo.familyNameKana
        this.info_person_form.apartment_number = customerInfo.apartment_number
        this.info_person_form.email = customerInfo.email
        this.info_person_form.secondEmail = customerInfo.secondEmail
        this.info_person_form.tel = customerInfo.tel
        this.info_person_form.secondTel = customerInfo.secondTel
        this.cityAddress = customerInfo.cityAddress
        this.zipCode1 = customerInfo.zipCode1
        this.zipCode2 = customerInfo.zipCode2
        this.prefectures = customerInfo.prefectures
        this.isForeign = customerInfo.isForeign
        this.$emit('checkProfileInfo', true)
      }
      this.checkiIsForeign()
    },
    checkiIsForeign() {
      if (this.zipCode1 && this.zipCode2) {
        if (this.zipCode1 === '000' && this.zipCode2 === '0000') {
          this.isForeign = true
          this.hasError = false
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
        }
      }
    },
    async getProfileInfo() {
      if (this.getInfoDetail === null) {
        this.profileInfo = this.profileMe
        if (this.profileInfo) {
          const postalCode = _.get(this.profileInfo, 'addresses[0].postalCode', '1000000')
          this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
          this.info_person_form.firstName = this.profileInfo.firstName
          this.info_person_form.familyName = this.profileInfo.familyName
          this.info_person_form.firstNameKana = this.profileInfo.firstNameKana
          this.info_person_form.familyNameKana = this.profileInfo.familyNameKana
          this.info_person_form.email = this.profileInfo.email
          this.info_person_form.secondEmail = this.profileInfo.secondEmail
          this.info_person_form.tel = this.profileInfo.tel
          this.info_person_form.secondTel = this.profileInfo.secondTel
          this.isForeign = this.profileInfo.isForeign
          if (postalCode) {
            this.cityAddress = _.get(this.profileInfo, 'addresses[0].address1', '')
            this.info_person_form.apartment_number = _.get(
              this.profileInfo,
              'addresses[0].address2',
              ''
            )
            this.zipCode1 = postalCode.substring(0, 3)
            this.zipCode2 = postalCode.substring(3, 7)
            this.getProfileMe()
          }
          this.checkiIsForeign()
          // 保持値がない（=初回遷移時）にprofile情報をstoreに保持する。
          this.updateInfoDetail()
          this.$emit('checkProfileInfo', true)
        }
      }
    },
    handleChangeEmail() {
      this.isEditEmail = false
      this.error_message_email = ''
    },
    handleChangePhone() {
      this.isEditPhone = false
      this.error_message_phone = ''
    },
    handleInputEmail() {
      this.isEditEmail = false
      if (this.email === 0) {
        this.myEmail = this.info_person_form.email
      } else {
        this.myEmail = this.info_person_form.secondEmail
      }
      return this.myEmail
    },
    saveMyEmail(myEmail) {
      this.myEmail = this.myEmail ? this.myEmail.trim() : this.myEmail
      if (this.validEmail(myEmail.trim())) {
        if (this.email === 0) {
          this.firstEmail = this.myEmail
          this.info_person_form.email = this.firstEmail
        } else {
          this.secondEmail = this.myEmail
          this.info_person_form.secondEmail = this.secondEmail
        }
        if (
          this.info_person_form.email === this.info_person_form.secondEmail ||
          this.info_person_form.secondEmail === this.info_person_form.email
        ) {
          this.hasError = true
          this.error_message_email =
            '入力したメールアドレスは既に存在しますので、再試行してください。'
        } else {
          this.isEditEmail = false
          this.error_message_email = ''
        }
      } else {
        this.hasError = true
        this.error_message_email = '有効なメールアドレスを入力してください'
        if (!this.myEmail) {
          this.error_message_email = 'メールアドレスを入力してください'
        }
      }
    },
    handleInputPhone() {
      this.isEditPhone = false
      if (this.phone === 0) {
        this.myPhone = this.info_person_form.tel
      } else {
        this.myPhone = this.info_person_form.secondTel
      }
      return this.myPhone
    },
    saveMyTel(myPhone) {
      if (this.validPhone(myPhone)) {
        if (this.phone === 0) {
          this.firstTel = this.myPhone
          this.info_person_form.tel = this.firstTel
        } else {
          this.secondTel = this.myPhone
          this.info_person_form.secondTel = this.secondTel
        }
        if (
          this.info_person_form.tel === this.info_person_form.secondTel ||
          this.info_person_form.secondTel === this.info_person_form.tel
        ) {
          this.isEditPhone = true
          this.hasError = true
          this.error_message_phone =
            '入力した電話番号は既に存在しますので、再試行してください'
          return
        } else {
          this.isEditPhone = false
          this.error_message_phone = ''
        }
        if (this.myPhone[0] === '0') {
          this.isEditPhone = false
          this.error_message_phone = ''
        } else {
          this.isEditPhone = true
          this.hasError = true
          this.error_message_phone = '有効な電話番号を入力してください'
        }
      } else {
        this.hasError = true
        this.error_message_phone = '有効な電話番号を入力してください'
        if (!this.myPhone) {
          this.error_message_phone = '電話番号を入力してください'
        }
      }
    },
    getProfileMe() {
      const zipCode = `${this.zipCode1}${this.zipCode2}`
      if (this.zipCode1 && this.zipCode2) {
        new YubinBangoCore(zipCode, (data) => {
          if (data !== null) {
            this.prefectures = data.region ? data.region : undefined
          }
        })
      }
    },
    validateZip1Number($event) {
      this.zipCode1 = $event.target.value.replace(/\D/g, "");
    },
    validateZip2Number($event) {
      this.zipCode2 = $event.target.value.replace(/\D/g, "");
    },
    validateZipcodeInput() {
      this.zipCode1 = this.inputAge(this.zipCode1)
      this.zipCode2 = this.inputAge(this.zipCode2)
    },
    async loadLocation() {
      this.validateZipcodeInput()
      this.isForeign = false
      if (this.zipCode1 && this.zipCode2) {
        if (this.zipCode1 === '000' && this.zipCode2 === '0000') {
          this.isForeign = true
          this.hasError = false
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
          this.error_message_zipcode = ''
          return
        }
        if (this.zipCode1.length < 3 || this.zipCode2.length < 4) {
          this.zipcodeError = true
          this.hasError = true
          this.prefectures = undefined
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
          this.error_message_zipcode = '郵便番号の形式が正しくありません。'
        }
        const zipCode = `${this.zipCode1}${this.zipCode2}`
        if (zipCode.length > 6) {
          new YubinBangoCore(zipCode, (data) => {
            if (data !== null) {
              if (data.region_id) {
                this.prefectureCode = data.region_id
                this.zipcodeError = false
                this.error_message_zipcode = ''
              } else {
                this.prefectureCode = '';
                this.zipcodeError = true
                this.hasError = true
                if (zipCode.length > 6) {
                  this.error_message_zipcode =
                    '郵便番号が存在しません。有効な郵便番号を入力してください'
                }
              }
              this.prefectures = data.region ? data.region : undefined
              const cityName = _.get(data, 'locality', '')
              const townName = _.get(data, 'street', '')
              this.cityAddress = [cityName, townName].filter((val) => val).join('')
              this.info_person_form.apartment_number = ''
            }
            this.checkMessageError()
          })
        } else {
          this.checkMessageError()
        }
      } else {
        this.zipcodeError = false
        this.checkMessageError()
        this.prefectures = undefined
        this.cityAddress = ''
      }
    },
    getLocation() {
      this.$store.dispatch(GET_LOCATE).then((data) => {
        this.locate = data.locate
      })
    },
    editEmail() {
      this.isEditEmail = true
    },
    editPhoneNumber() {
      this.myPhone = this.myPhone ? this.myPhone.replaceAll('-', '') : ''
      this.isEditPhone = true
    },
    CheckErrorMessagePhoneAndEmail() {
      this.textUnregister = ''
      this.hasError = false
      if (this.myEmail === '') {
        this.hasError = true
        this.error_message_email = 'メールアドレスを入力してください'
      } else {
        this.error_message_email = ''
      }
      if (this.myPhone === '') {
        this.hasError = true
        this.error_message_phone = '電話番号を入力してください'
      } else {
        this.error_message_phone = ''
      }
    },
    checkMessageError() {
      this.hasError = false
      if (!this.prefectures) {
        this.hasError = true
        this.error_message_prefectures = '都道府県を入力してください'
      } else {
        this.error_message_prefectures = ''
      }
      if (!this.cityAddress || this.cityAddress.trim() === '') {
        this.hasError = true
        this.error_message_cityAddress = '市区町村・番地を入力してください'
      } else {
        this.error_message_cityAddress = ''
      }
      if (!this.zipcodeError) {
        if (this.zipCode1 === '' || this.zipCode2 === '') {
          this.hasError = true
          this.error_message_zipcode = '郵便番号を入力してください'
        } else {
          this.error_message_zipcode = ''
        }
      }
      if (this.hasError) {
        this.$emit('checkProfileInfo', false)
      } else {
        this.$emit('checkProfileInfo', true)
      }
    },
    getPrefectureCode() {
      const prefIndex = [];
      this.getPrefecturesList.filter((prefectures, idx) => {
        if (prefectures.value == this.prefectures) {
          prefIndex.push(idx);
        }
        return prefectures.value == this.prefectures;
      });
      if (prefIndex && prefIndex.length == 1) {
        return (Number(prefIndex[0]) + 1).toString();
      }
      return "";
    },
    /**
     * store（bs_app.info_detail）に入力されている値をセット
     * @params {{ void }}
     */
    updateInfoDetail() {
      this.prefectureCode = this.getPrefectureCode();
      const info = {
        memberId: this.info_person_form.memberId,
        firstName: _.get(this.info_person_form, 'firstName', ''),
        familyName: _.get(this.info_person_form, 'familyName', ''),
        firstNameKana: _.get(this.info_person_form, 'firstNameKana', ''),
        familyNameKana: _.get(this.info_person_form, 'familyNameKana', ''),
        zipCode1: this.zipCode1,
        zipCode2: this.zipCode2,
        prefectures: this.prefectures,
        cityAddress: this.cityAddress ? this.cityAddress.trim() : this.cityAddress,
        apartment_number: _.get(this.info_person_form, 'apartment_number', ''),
        info_person: this.info_person,
        email: this.info_person_form.email,
        secondEmail: this.info_person_form.secondEmail,
        tel: this.info_person_form.tel,
        secondTel: this.info_person_form.secondTel,
        myEmail: this.myEmail,
        myPhone: this.myPhone,
        isForeign: this.isForeign,
        prefectureCode: this.prefectureCode
      }
      this.$store.dispatch(UPDATE_INFO_DETAIL, info).then(() => {})
    },
    gotoScreen(code) {
      const { menuNo, planId, roomId } = this.$route.query
      switch (code) {
        case 1:
          this.$router.push({ path: '/' })
          return
        case 2:
          this.$router.push({ path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}` })
      }
    },
    // 入力値のバリデーション
    checkValidateInput() {
      let hasError = false

      // 郵便番号関連バリデーション ////////////////////////
      if (!this.zipCode1 || !this.zipCode2) {
        // 郵便番号が入力されているか
        hasError = true
        this.error_message_zipcode = '郵便番号を入力してください'
      } else if (this.zipCode1.length !== 3 || this.zipCode2.length !== 4) {
        // 郵便番号が不正な値でないか
        hasError = true
        this.error_message_zipcode = '郵便番号の形式が正しくありません。'
      } else {
        this.error_message_zipcode = ''
      }

      // 住所関連バリデーション ////////////////////////////
      if (this.zipCode1 !== '000' || this.zipCode2 !== '0000') {
        this.isForeign = false

        if (!this.prefectures) {
          // 都道府県が入力されているか
          hasError = true
          this.error_message_prefectures = '都道府県を入力してください'
        } else {
          this.error_message_prefectures = ''
        }

        if (!this.cityAddress) {
          // 市区町村・番地が入力されているか
          hasError = true
          this.error_message_cityAddress = '市区町村・番地を入力してください'
        } else {
          this.error_message_cityAddress = ''
        }
      }

      // 電話番号関連バリデーション ////////////////////////
      if (this.info_person_form.tel && this.info_person_form.tel.length > 0 && !this.info_person_form.tel.match(/^[0-9]+$/)) {
        // 電話番号に半角数字以外の文字が含まれているか
        hasError = true
        this.error_message_tel = '半角数字のみを入力してください。ハイフンの入力は不要です。'
      } else if (!this.info_person_form.tel || this.info_person_form.tel.length < 10) {
        // 電話番号が空または10桁未満の場合
        hasError = true
        this.error_message_tel = '10桁以上の数値を入力してください。'
      } else {
          this.error_message_tel = ''
      }

      return hasError
    },
    async handleNext() {
      const errorInput = this.checkValidateInput()
      this.updateInfoDetail()
      if (!errorInput) {
        this.$emit('updateInfoComplete')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.content {
  &__note {
    &--tel {
      color: #73767A;
    }
  }
}
</style>
